var unstyledAnchor = 'fx_2d2fb1e5_1mi6qzi0';

export { unstyledAnchor };
//# sourceMappingURL=primitive-anchor.vanilla.mjs.map
